import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export function provideStatistics() {
  return [provideCharts(withDefaultRegisterables())];
}
